module.exports = __webpack_public_path__ + "static/media/marketing.9ad0745b.svg";